import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader } from 'mdb-react-ui-kit';
import React from 'react';

const ConfirmAlertMS = ({ showSSODisableModal, setShowSSODisableModal, messagehead, message, onConfirm, onCancel }) => {
    return (
        <><MDBModal
            tabIndex="-1"
            open={showSSODisableModal}
            setOpen={setShowSSODisableModal}
        >
            <MDBModalDialog centered>
                <MDBModalContent>
                    <MDBModalHeader>
                        <h5 className="modal-title">{messagehead}</h5>
                    </MDBModalHeader>
                    <MDBModalBody>
                        {message}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="secondary"
                            onClick={() => onCancel()}
                        >
                            Cancel
                        </MDBBtn>
                        <MDBBtn
                            onClick={() => onConfirm()}
                        >
                            Continue
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
        </>
    );
};

export default ConfirmAlertMS;